import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
// import Edit from "@material-ui/icons/Edit";
import CalendarToday from "@material-ui/icons/CalendarToday";
import { dateformat } from "../../../../../../../../../utils/dateFormat";
import { useDetailsInfoStyles } from "./styles";
import Grid from "@material-ui/core/Grid";
// import Button from "@material-ui/core/Button";
// import { Link, useParams } from "react-router-dom";
import { AttendanceLocalDepartment } from "../../../../../../../../../@types/attendance-local-department";

type DetailsInfoProps = {
    department: AttendanceLocalDepartment;
};

export default function DetailsInfo({ department }: DetailsInfoProps) {
    // const { slug } = useParams<{ slug: string }>();
    const { classes } = useDetailsInfoStyles();

    return (
        <Paper elevation={3}>
            <Box className={classes.head}>
                <Box className={classes.container}>
                    <Box className={classes.header}>
                        <Typography className={classes.title}>
                            {department?.setor?.nome || 'Misto'}
                        </Typography>
                        <Box
                            className={`${classes.badge} ${department?.ativo ? classes.active : classes.inactive
                                }`}
                        >
                            {department?.ativo ? "Ativo" : "Inativo"}
                        </Box>
                    </Box>
                    <Box className={classes.infosContainer}>
                        <Box className={classes.infoContainer}>
                            <CalendarToday className={classes.icons} />
                            <Typography className={classes.infoContainerText}>
                                Adicionado: {dateformat(department?.created_at, true)}
                            </Typography>
                        </Box>
                        <Box className={classes.infoContainer}>
                            <CalendarToday className={classes.icons} />
                            <Typography className={classes.infoContainerText}>
                                Atualizado em: {dateformat(department?.updated_at, true)}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {/* <Box className={classes.headerButtonGroup}>
          {!attendanceLocal?.horario_unidade ? (
            <ExpedientFormCreate slug={slug} />
          ) : (
            <ExpedientFormUpdate
              slug={slug}
              expedient={attendanceLocal.horario_unidade}
            />
          )}
          <Button
            component={Link}
            to={`/locais-de-atendimento/${slug}/editar`}
            startIcon={<Edit fontSize="small" />}
            className={classes.editButton}
          >
            Editar
          </Button>
        </Box> */}
            </Box>
            <Divider />
            <Box className={classes.content}>
                <Typography className={classes.subtitle}>
                    Informações do setor
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={4} className={classes.localInfoContainer}>
                        <Typography className={classes.localInfoTitle}>
                            Órgão Responsável
                        </Typography>
                        <Typography className={classes.localInfoText}>
                            {department?.setor ? (
                                `${department?.setor?.orgao.sigla} - ${department?.setor?.orgao.nome}`
                            ) : 'Misto'}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.localInfoContainer}>
                        <Typography className={classes.localInfoTitle}>
                            Local de Atendimento
                        </Typography>
                        <Typography className={classes.localInfoText}>
                            {department?.unidade?.nome || 'Misto'}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.localInfoContainer}>
                        <Typography className={classes.localInfoTitle}>
                            Setor
                        </Typography>
                        {department?.setor?.nome || 'Misto'}
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}
